import { Box, Dialog, Grid, IconButton, Typography } from '@mui/material'
import React from 'react'
import { HeadingText } from '../StyledComponents'
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { Link } from 'react-router-dom';
import AboutProject from './AboutProject';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@emotion/react';

function Works() 
{
    let projects = [
        {
            projectName: "SkillArena",
            caption: "Student Task & Competition Monetization Platform",
            imgSrc: "images/projects/skillArena/main.webp",
            imgs: [
                "images/projects/skillArena/img1.webp",
                "images/projects/skillArena/img2.webp",
                "images/projects/skillArena/img3.webp",
                "images/projects/skillArena/img4.webp",
                "images/projects/skillArena/img5.webp",
                "images/projects/skillArena/img6.webp",
                "images/projects/skillArena/img7.webp",
                "images/projects/skillArena/img8.webp",
                "images/projects/skillArena/img9.webp",
                "images/projects/skillArena/img10.webp",
                "images/projects/skillArena/img11.webp",
                "images/projects/skillArena/img12.webp",
                "images/projects/skillArena/img13.webp",
                "images/projects/skillArena/img14.webp",
                "images/projects/skillArena/img15.webp",
                "images/projects/skillArena/img16.webp",
                "images/projects/skillArena/img17.webp",
                "images/projects/skillArena/img18.webp"
            ],
            link: "https://github.com/Sharief2854",
            details: {
                description: "A high-performance, full-stack competition and skill monetization platform designed for hosting timed programming challenges, technical quizzes, and project submission tournaments with real-time leaderboards, automated prize payouts, escrow vault tracking, and Zero-Default-Trust Host Admin Access Delegation.",
                features: [
                    "Multi-role architecture: Chief Super Admin, Host Admin, and Student Competitor",
                    "Interactive contest formats: Timed MCQ Quizzes, Coding Challenges & Project Template Uploads",
                    "Zero-Default-Trust Access Delegation and granular administrative governance",
                    "Razorpay payment gateway integration with wallet balance, automated refunds & escrow payouts",
                    "Real-time dynamic leaderboards, Top 3 podium, and score/completion time metrics",
                    "Secure single-active-session enforcement with HTTP-only cookies and MongoStore session management"
                ],
                technologies: ["React 19", "Node.js", "Express", "MongoDB", "Mongoose", "Razorpay", "Tailwind CSS", "MUI", "Vite"]
            }
        },
        {
            projectName: "WorkEasy",
            caption: "1-Click Developer Workspace & App Launcher",
            imgSrc: "images/projects/workEasy/main.webp",
            imgs: [
                "images/projects/workEasy/img1.webp",
                "images/projects/workEasy/img2.webp",
                "images/projects/workEasy/img3.webp",
                "images/projects/workEasy/img4.webp",
                "images/projects/workEasy/img5.webp",
                "images/projects/workEasy/img6.webp",
                "images/projects/workEasy/img7.webp"
            ],
            link: "https://github.com/Sharief2854/workEasy",
            details: {
                description: "A high-performance Windows desktop application built with Electron, React, and Tailwind CSS to eliminate daily startup friction by orchestrating and launching developer workspaces, IDEs, database tools, browser tabs, and scripts in a single click.",
                features: [
                    "1-Click multi-tool and workspace orchestration",
                    "Automatic application detector across installed Windows software",
                    "Direct project directory launching in VS Code",
                    "Batch browser URL portal launcher",
                    "Configurable stagger delay to prevent CPU spikes",
                    "Auto-exit on launch for a clutter-free desktop",
                    "JSON workspace template backup, export, and restore"
                ],
                technologies: ["Electron", "React", "Node.js", "Tailwind CSS", "Vite", "JavaScript"]
            }
        },
        {
            projectName: "ThunderBoard",
            caption: "Intelligent Desktop Teaching Board & Code Canvas",
            imgSrc: "images/projects/thunderBoard/main.webp",
            imgs: [
                "images/projects/thunderBoard/img1.webp",
                "images/projects/thunderBoard/img2.webp",
                "images/projects/thunderBoard/img3.webp",
                "images/projects/thunderBoard/img4.webp",
                "images/projects/thunderBoard/img5.webp",
                "images/projects/thunderBoard/img6.webp",
                "images/projects/thunderBoard/img7.webp",
                "images/projects/thunderBoard/img8.webp",
                "images/projects/thunderBoard/img9.webp"
            ],
            link: "https://github.com/Sharief2854/thunder-board",
            details: {
                description: "A modern, high-performance, offline-first desktop whiteboard designed for technical instructors, developers, and visual thinkers. Combines ultra-fluid freehand drawing with interactive syntax-highlighted code cards, VS Code-style color studio, and universal offline HTML lecture exports.",
                features: [
                    "Zero-latency freehand inking with custom pen, pencil, and highlighter",
                    "Interactive movable and resizable syntax-highlighted code cards (PrismJS)",
                    "VS Code-style color studio with 2D picker and toolbar color pinning",
                    "Freehand geometric shape recognition and vector snapping",
                    "Standalone offline interactive HTML lecture export with code copy button",
                    "Handwritten code highlighter powered by custom calibration model",
                    "Obsidian blackboard & clean whiteboard distraction-free canvas"
                ],
                technologies: ["Electron", "React", "TypeScript", "Tailwind CSS", "Vite", "PrismJS"]
            }
        },
        {
            projectName: "LMS Platform (Chaduvuko)",
            caption: "Learning Management System with Multi-Role Portals",
            imgSrc: "images/projects/lms/main.webp",
            imgs: [
                "images/projects/lms/img1.webp"
            ],
            link: "https://chaduvuko.vercel.app/",
            details: {
                description: "A feature-rich Learning Management System (LMS) developed with the MERN stack (MongoDB, Express, React, Node.js), featuring dedicated role-based access for Trainers, Students, and Admins.",
                features: [
                    "Role-based portals (Trainer, Student, Admin)",
                    "Course management and content distribution",
                    "Student enrollment and progress tracking",
                    "Real-time assignment and evaluation workflows",
                    "Secure authentication and data management",
                    "Responsive UI across mobile and desktop"
                ],
                technologies: ["HTML", "CSS", "JavaScript", "React", "Node.js", "Express", "MongoDB"]
            }
        },
        {
            projectName: "QR Code Based Attendance",
            caption: "Attendance Management System",
            imgSrc: "images/projects/attend/main.webp",
            imgs:[
                "images/projects/attend/img1.png",
                "images/projects/attend/img2.png",
                "images/projects/attend/img3.png",
                "images/projects/attend/img4.png",
                "images/projects/attend/img5.png",
                "images/projects/attend/img6.png"
            ],
            link:"https://shariefprojectqrcodeattendance.netlify.app/",
            details: {
                description: "A smart attendance system that allows students/employees to mark attendance by scanning a QR code. The system ensures secure and real-time data management.",
                features: [
                    "Scan QR code for attendance",
                    "Real-time data synchronization",
                    "Admin panel for user management",
                    "Attendance history tracking",
                    "Secure authentication system"
                ],
                technologies: ["React", "Node.js", "Express", "MongoDB", "MUI", "QR Code Scanner"]
            }
        },
        {
            projectName: "Course Registration App",
            caption: "A Modern and Responsive Course Registration Platform",
            imgSrc: "images/projects/courseApp/main.webp",
            link: "https://mycourses-sharief.netlify.app/",
            imgs: [
                "images/projects/courseApp/img1.png",
                "images/projects/courseApp/img2.png",
                "images/projects/courseApp/img3.png",
                "images/projects/courseApp/img4.png",
                "images/projects/courseApp/img5.png",
                "images/projects/courseApp/img6.png",
                "images/projects/courseApp/img7.png",
                "images/projects/courseApp/img8.png",
                "images/projects/courseApp/img9.png",
                "images/projects/courseApp/img10.png",
                "images/projects/courseApp/img11.png",
                "images/projects/courseApp/img12.png"
            ],
            details: {
                description: "A fully responsive and interactive course registration platform built using React and Material-UI, providing a seamless user experience for browsing, selecting, and enrolling in courses.",
                features: [
                    "Modern and responsive UI",
                    "Course search and filtering",
                    "User authentication and registration",
                    "Smooth animations and transitions",
                    "Dynamic course details page",
                    "Secure form validation",
                    "Material-UI components for a professional look",
                    "Mobile-friendly design"
                ],
                technologies: [
                    "React.js",
                    "Material-UI (MUI)"
                ]
            }
        },

        {
            projectName: "Excel CRUD App",
            caption: "Excel Data Manager",
            imgSrc: "images/projects/excelCrud/main.webp",
            link: "https://github.com/Sharief2854",
            imgs: [
                "images/projects/excelCrud/img1.png",
                "images/projects/excelCrud/img2.png",
                "images/projects/excelCrud/img3.png",
                "images/projects/excelCrud/img4.png",
                "images/projects/excelCrud/img5.png",
                
                
            ],
            details: {
                description: "An application for managing Excel sheets, allowing users to upload, view, edit, delete, and download data efficiently. Uploaded data is stored in the database for persistent management.",
                features: [
                    "Upload and display Excel sheets",
                    "Edit and delete records within the sheet",
                    "Download modified Excel sheets",
                    "Data validation and error handling",
                    "User-friendly interface for managing records"
                ],
                technologies: ["React", "Node.js", "Express", "MongoDB", "Material-UI"]
            }
        },

        // {
    //         projectName: "Flipkart Clone",
    //         caption: "E-commerce Platform",
    //         imgSrc: "images/projects/flipkart.jpeg",
    //         link: "https://github.com/Sharief2854",

    //         details: {
    //             description: "An e-commerce web application inspired by Flipkart, featuring product listings, shopping cart functionality, and secure online transactions.",
    //             features: [
    //                 "User authentication (login/register)",
    //                 "Product listing and categorization",
    //                 "Shopping cart functionality",
    //                 "Order history and tracking",
    //                 "Payment gateway integration"
    //             ],
    //             technologies: ["React", "Redux", "Node.js", "Express", "MongoDB", "MUI", "Stripe"]
    //         }
    //     },
    //     {
    //         projectName: "Register and Login",
    //         caption: "User Authentication System",
    //         imgSrc: "images/projects/loginReg.jpeg",
    //         link: "https://github.com/Sharief2854",

    //         details: {
    //             description: "A secure login and registration system with JWT authentication, password hashing, and role-based access control.",
    //             features: [
    //                 "Secure user authentication",
    //                 "JWT-based authentication",
    //                 "Password hashing with bcrypt",
    //                 "Role-based access control",
    //                 "Forgot password & email verification"
    //             ],
    //             technologies: ["React", "Node.js", "Express", "MongoDB", "JWT", "MUI"]
    //         }
    //     },
        
    //     {
    //         projectName: "Calculator App",
    //         caption: "Basic Utility App",
    //         imgSrc: "images/projects/car.jpg",
    //         link: "https://github.com/Sharief2854",

    //         details: {
    //             description: "A simple calculator application that supports basic arithmetic operations and includes a dark/light mode.",
    //             features: [
    //                 "Basic arithmetic operations",
    //                 "Dark/light theme mode",
    //                 "Keyboard support",
    //                 "Memory save and recall feature",
    //                 "Responsive design"
    //             ],
    //             technologies: ["HTML", "CSS", "JavaScript", "React"]
    //         }
    //     }
    ];


    const[showAboutProject,setShowAboutProject]=React.useState(false)
    const [project, setProject] = React.useState({});

    const [open, setOpen] = React.useState(false);
    let theme=useTheme();
    const handleClose = () => {
        setOpen(false);
    };

  return (
    <Box sx={{position:"relative"}} id="works">
        <Box sx={{ textAlign: "center" }} my={5} data-aos="fade-up" data-aos-duration="2000">
              <HeadingText text="Works" mb={5} variant='h1' >
                Works
            </HeadingText>
            <Typography variant='h7' sx={{ color: "shade.light" }} >
                Building seamless digital experiences through robust full stack development.
            </Typography>
        </Box>  
        
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        
            sx={{
                // backgroundColor:"shade.light",
                "& .MuiDialog-paper": { 
                    width: { xs: "98vw", sm: "98vw", md: "80vw"},  
                    maxWidth: "none",
                    // height: "80vh", 
                    // maxHeight: "600px", 
                    borderRadius:4,
                    backgroundColor:"background.default",
                    border:`1px solid ${theme.palette.primary.main}`,
                    // borderTopRightRadius:"70px",
                    margin:"0px",
                    padding: 2,
                    overflowX: "hidden"

                },
            }}
        >
              <IconButton
                  aria-label="close"
                  onClick={handleClose}
                  sx={{
                      position: 'absolute',
                      right: -1,
                      top: -1,
                      color: "primary.main",
                      backgroundColor:"shade.main",
                  }}
              >
                  <CloseIcon />
              </IconButton>
            <AboutProject project={project} />
        </Dialog>
        



        <Grid container spacing={4} justifyContent="center">
            {
                projects.map((project, index) => {
                    return (
                        <Grid item xs={12} sm={6} md={4} key={index} data-aos="fade-up" data-aos-duration="2000">
                            <Box 
                                sx={{ 
                                    borderRadius: 3, 
                                    border: "2px solid",
                                    borderColor: "primary.main",
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    backgroundColor: "shade.main",
                                    overflow: "hidden",
                                    boxShadow: `0 4px 15px rgba(0,0,0,0.3)`,
                                    transition: "all 0.3s ease-in-out",
                                    '&:hover': {
                                        transform: "translateY(-6px)",
                                        boxShadow: `0 10px 25px ${theme.palette.primary.main}40`,
                                    }
                                }}
                            >
                                <Box
                                    sx={{
                                        width: "100%",
                                        height: { xs: 210, sm: 220, md: 230 },
                                        overflow: "hidden",
                                        position: "relative",
                                        cursor: "pointer",
                                        backgroundColor: "rgba(0,0,0,0.4)"
                                    }}
                                    onClick={() => {
                                        setProject(project);
                                        setOpen(true);
                                        return setShowAboutProject(true);
                                    }}
                                >
                                    <Box
                                        component="img" 
                                        src={project.imgSrc} 
                                        alt={project.projectName}
                                        loading="lazy"
                                        decoding="async"
                                        sx={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            objectPosition: "top center",
                                            transition: "transform 0.4s ease-out",
                                            '&:hover': {
                                                transform: "scale(1.08)"
                                            }
                                        }}
                                    />
                                </Box>
                                
                                <Box 
                                    px={2.5}
                                    py={2}
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        flexGrow: 1,
                                        backgroundColor: "shade.main",
                                        borderTop: `1px solid ${theme.palette.primary.main}30`
                                    }}
                                >
                                    <Typography 
                                        variant='h6' 
                                        color="primary.main" 
                                        fontWeight="bold"
                                        component="a"
                                        href={project.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                            textDecoration: "none",
                                            transition: "color 0.2s ease",
                                            '&:hover': {
                                                color: "white"
                                            },
                                            '.icon': {
                                                transition: "transform 0.2s ease-in-out"
                                            },
                                            '&:hover .icon': {
                                                transform: "translate(2px, -2px)"
                                            }
                                        }}
                                    >
                                        {project.projectName}
                                        <ArrowOutwardIcon className='icon' fontSize="small" />
                                    </Typography>
                                    <Typography 
                                        variant="body2"
                                        sx={{ color: "shade.light", mt: 0.5 }}
                                    >
                                        - {project.caption}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                    )
                })
            }
        </Grid>
    </Box>
  )
}

export default Works

